var exports = {
  "JC": "UserProfilePopout.module__role___NGY5NE",
  "s$": "UserProfilePopout.module__roleRemoveIcon___NGY5NE",
  "Bx": "UserProfilePopout.module__iconSmall___NGY5NE",
  "bc": "UserProfilePopout.module__profileCustomStatus___NGY5NE",
  "CQ": "UserProfilePopout.module__profileCustomStatusText___NGY5NE",
  "ZB": "UserProfilePopout.module__profileDisplayName___NGY5NE",
  "yn": "UserProfilePopout.module__profileDataWarning___NGY5NE",
  "zF": "UserProfilePopout.module__profilePopoutCard___NGY5NE",
  "wt": "UserProfilePopout.module__profileSidebarCard___NGY5NE",
  "sn": "UserProfilePopout.module__sidebarMutuals___NGY5NE",
};

module.exports = exports;
